
import React from 'react'
import HolidayListTable from './Components/HolidayListTable'
import AddItemBtn from "Common/Custom/AddItemBtn";
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";

const HolidayList = () => {
    return (
        <PageBody
            card={true}
            headerchildren={
                <>
                    <HeadingOne>Holiday List</HeadingOne>
                    <AddItemBtn url="add-holiday" title="Add Holiday" />
                </>
            }>

            {/* Table section */}
            <div className="col-12">
                <HolidayListTable />
            </div>
        </PageBody>
    );
};

export default HolidayList;
